import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { resetConsent } from '../utils/chatConsent';

export default function Footer() {
  const location = useLocation();
  const isRamseyTheme = location.pathname === '/ramsey';

  // One look for every footer link: no wrapping inside a link, one hover colour
  const linkClass = `whitespace-nowrap transition-colors ${
    isRamseyTheme ? 'text-[#d0ccc5] hover:text-[#f4f0e9]' : 'text-slate-400 hover:text-[#6FB6E8]'
  }`;
  // Phones: a two-column grid so nothing is stranded alone; tablets: one full row per group; large screens: groups side by side
  const listClass = 'grid grid-cols-2 gap-x-8 gap-y-3 sm:flex sm:flex-wrap';

  return (
    <footer className={`${
      isRamseyTheme 
        ? 'bg-[#323639] py-16 border-t border-[#d0ccc5]/10' 
        : 'bg-[#12141d] py-16 border-t border-white/5'
    }`}>
      <div className="max-w-6xl mx-auto px-6 text-sm">
        <nav aria-label="Footer" className="flex flex-col gap-8 lg:flex-row lg:justify-between">
          <ul className={listClass}>
            <li>
              <a href="https://docs.dopove.com" className={linkClass}>Documentation</a>
            </li>
            <li>
              <Link to="/download" className={linkClass}>Downloads</Link>
            </li>
            <li>
              <a href="https://dev.to/dopove" className={linkClass}>Community</a>
            </li>
            <li>
              <a href="https://github.com/Dopove" target="_blank" rel="noopener noreferrer" className={linkClass}>GitHub</a>
            </li>
          </ul>
          <ul className={listClass}>
            <li>
              <Link to="/privacy-policy" className={linkClass}>Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-service" className={linkClass}>Terms of Service</Link>
            </li>
            <li>
              <Link to="/cookie-policy" className={linkClass}>Cookie Policy</Link>
            </li>
            <li>
              <button type="button" onClick={resetConsent} className={linkClass}>Chat preferences</button>
            </li>
          </ul>
        </nav>
        <p className={`mt-10 pt-8 border-t text-xs ${isRamseyTheme ? 'border-[#d0ccc5]/10 text-[#d0ccc5] font-light' : 'border-white/5 text-slate-500'}`}>
          &copy; 2026 Dopove Private Limited. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
